import { Handle, Position } from 'react-flow-renderer';

export const handleStyle = {
    background: 'transparent',
    border: 'none',
    height: 1,
    minHeight: 1,
    minWidth: 1,
    width: 1,
};

const NodeHandles = ({
    extra,
}) => (
    <>
        <Handle position={Position.Left} style={handleStyle} type="target" />
        <Handle position={Position.Right} style={handleStyle} type="source" />
        {extra}
    </>
);

export default NodeHandles;
